import * as XLSX from "xlsx";
import { getAppInsights } from "../../appInsights";
import { DelegeeData } from "../../context/store/reducers/importDelegations.reducer";

export const sheetName = {
  importDelegees: "Import Delegees",
} as const;

export const columns = {
  delegeeEmail: "Delegee Email Address",
  delegeeName: "Delegee Name",
  rowNumber: "__rowNum__",
} as const;

export type ReadDelegeeExcelResult =
  | { ok: true; data: DelegeeData[] }
  | { ok: false; error: string };

export function readDelegeesExcel(reader: FileReader): ReadDelegeeExcelResult {
  const binData = reader.result;
  let wb: XLSX.WorkBook;
  try {
    wb = XLSX.read(binData, { type: "binary" });
  } catch (error) {
    if (error instanceof Error) {
      getAppInsights()?.trackException({
        exception: error,
        properties: {
          action: "ReadDelegeesExcel",
        },
      });
    }
    return { ok: false, error: "invalid file" };
  }

  const hasTheCorrectSheet = wb.SheetNames && wb.SheetNames.includes(sheetName.importDelegees);
  if (!hasTheCorrectSheet) {
    return { ok: false, error: "no sheet" };
  }

  const data = getDelegeesFromWorkbook(wb);
  return { ok: true, data };
}

function getDelegeesFromWorkbook(wb: XLSX.WorkBook): DelegeeData[] {
  const rows: any[] = XLSX.utils.sheet_to_json(wb.Sheets[sheetName.importDelegees]);
  const delegeesToImport: DelegeeData[] = [];
  rows.forEach((row) => {
    if (row[columns.delegeeName] || row[columns.delegeeEmail]) {
      delegeesToImport.push({
        name: { value: String(row[columns.delegeeName] || ''), isValid: true },
        emailAddress: { value: row[columns.delegeeEmail], isValid: true },
        lineNumber: row[columns.rowNumber] + 1,
      });
    }
  });

  return delegeesToImport;
}
